module.exports = __webpack_public_path__ + "img/pizza1.22da890c.png";